export interface JournalistCategoryModel {
    id: number,
    description: string,
    score: number,
    codeMetric: number | null,
    startofPeriod: Date | null,
    endofPeriod: Date | null
}

export const journalistCategoryModelInitial: JournalistCategoryModel = {
    id: 0,
    description: '',
    score: 0,
    codeMetric: null,
    startofPeriod: null,
    endofPeriod: null,
};